import React from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-apollo';
import { get } from 'lodash-es';
import { Spinner } from '../../../containers';
import { ROUTE_TO_ADMIN_TRANSACTIONS_PAGE } from '../../../constants/routes';
import { GetSingleUserTransactionQuery } from '../../../operations/queries/GetUserTransactionsQuery';
import { handleRequestError } from '../../../constants/errorCodes';
import { SingleTransactionPreview } from './SingleTransactionPreview';
import { GetUserDataQuery } from '../../../operations/queries/GetUsersQuery';

export const AdminUserTransactionPreviewPage = () => {
  const dispatch = useDispatch();
  const { transactionId } = useParams();

  const { data, loading, error, fetchMore } = useQuery(GetSingleUserTransactionQuery, {
    variables: { filter: { confirmationCode: transactionId } },
    onError: error => handleRequestError(error, dispatch),
    fetchPolicy: 'network-only',
  });

  const transaction = get(data, 'getPayments.payments[0]', null);

  const {
    data: userData,
    loading: userLoading,
    error: userError,
  } = useQuery(GetUserDataQuery, {
    variables: { id: parseInt(get(data, 'getPayments.payments[0].userId', 0), 10) },
    onError: error => handleRequestError(error, dispatch),
    fetchPolicy: 'network-only',
    skip: !get(data, 'getPayments.payments[0].userId', false),
  });

  const user = get(userData, 'getUsers.users[0]', {});

  if (loading || (!data && !error) || userLoading || (!userData && !userError)) {
    return <Spinner className="spinner-positioning" />;
  }
  if (get(data, 'getPayments.payments', []).length < 1) {
    return <Redirect to={ROUTE_TO_ADMIN_TRANSACTIONS_PAGE} />;
  }

  return <SingleTransactionPreview transaction={transaction} user={user} fetchMore={fetchMore} />;
};
